/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Number_To_Keep_LabelInputs */



/**
* | output |
* | --- |
* | "Number of Backups to Keep" |
*
* @param {Options_Backup_Number_To_Keep_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_number_to_keep_label = /** @type {((inputs?: Options_Backup_Number_To_Keep_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Number_To_Keep_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nombre de sauvegardes à conserver")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzahl der aufzubewahrenden Backups")
	if (locale === "it") return /** @type {LocalizedString} */ ("Numero di backup da conservare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Количество резервных копий, которые необходимо хранить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Número de copias de seguridad a mantener")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("要保留的备份数量")
	if (locale === "ja") return /** @type {LocalizedString} */ ("保存するバックアップの数")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बैकअप की संख्या जिसे रखना है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Número de backups a manter")
	return /** @type {LocalizedString} */ ("Number of Backups to Keep")
});